import { type TranslationIDs } from '@capsicum/common';
import { type OnboardingMessages } from '@capsicum/features/onboard/shared';

export const onboardingMessages: Record<OnboardingMessages, { id: TranslationIDs }> = {
	onboardingDropHeadlineScreen0: {
		id: 'onboarding.screen0Dropheadline'
	},
	onboardingDropHeadlineScreen2: {
		id: 'onboarding.screen2Dropheadline'
	},
	onboardingDropHeadlineScreen3: {
		id: 'onboarding.screen3Dropheadline'
	},
	onboardingGetStartedButton: {
		id: 'onboarding.buttons.getStarted'
	},
	onboardingHeadlineScreen0: {
		id: 'onboarding.screen0Headline'
	},
	onboardingHeadlineScreen1: {
		id: 'onboarding.screen1Headline'
	},
	onboardingHeadlineScreen2: {
		id: 'onboarding.screen2Headline'
	},
	onboardingHeadlineScreen3: {
		id: 'onboarding.screen3Headline'
	},
	onboardingLogInButton: {
		id: 'onboarding.buttons.logIn'
	},
	onboardingNextButton: {
		id: 'onboarding.buttons.next'
	},
	onboardingRegisterButton: {
		id: 'onboarding.buttons.register'
	}
};
